document.addEventListener("DOMContentLoaded", function(){

  // Tabs
  document.querySelectorAll(".tab-btn").forEach(btn=>{
    btn.addEventListener("click", function(){
      document.querySelectorAll(".tab-btn").forEach(b=>b.classList.remove("active"));
      document.querySelectorAll(".tab-content").forEach(c=>c.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(btn.dataset.tab).classList.add("active");
    });
  });

  // Pagination arrows
  document.addEventListener("click", function(e){

    const button = e.target.closest(".nav");
    if(!button) return;

    const grid = button.closest(".custom-grid");
    const handle = grid.dataset.collection;
    let page = parseInt(grid.dataset.page) || 1;

    if(button.classList.contains("next")){
      page++;
    } else if(button.classList.contains("prev") && page > 1){
      page--;
    }

    fetch(`/collections/${handle}/products.json?limit=9&page=${page}`)
      .then(res => res.json())
      .then(data => {

        if(!data.products || data.products.length === 0) return;

        grid.dataset.page = page;

        let html = "";

        data.products.slice(0,9).forEach(product => {

          let image = product.images?.length
            ? product.images[0].src + "&width=600"
            : "https://via.placeholder.com/400";

          let price = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(product.variants[0].price);

          html += `
            <div class="grid-item">
              <div class="product-card">
                <a href="/products/${product.handle}" class="image-card">
                  <img src="${image}" loading="lazy" alt="${product.title}" />
                </a>
                <h4 class="product-title">${product.title}</h4>
                <p class="price">${price}</p>
              </div>
            </div>
          `;
        });

        // Always add arrows
        html += `
          <div class="grid-item arrow-box">
            <button class="nav prev"><img src="https://cdn.shopify.com/s/files/1/0570/3339/2197/files/ArrowCircle_Red_Left.png"></button>
      <button class="nav next"><img src="https://cdn.shopify.com/s/files/1/0570/3339/2197/files/ArrowCircle_Red_Right.png"></button>
      
          </div>
        `;

        grid.innerHTML = html;

        // Disable prev on first page
        if(page === 1){
          const prevBtn = grid.querySelector(".prev");
          if(prevBtn){
            prevBtn.style.opacity = "0.3";
            prevBtn.style.pointerEvents = "none";
          }
        }

      })
      .catch(err => console.log(err));

  });

});